export default {
  button: {
    id: 'insurance_cart_browse',
    defaultMessage: 'Browse Protection Plans',
  },
  description: {
    id: 'insurance_cart_title',
    defaultMessage:
      'Life happens. Save on unexpected repairs for your {deviceName}',
  },
}
